/** A list of records. The one on the platter shows an equaliser instead of a time. */

import { type Component, For, Show } from 'solid-js';
import { playFromList } from '../../app/commands.ts';
import { fmtTime } from '../../lib/format.ts';
import { track as currentTrack } from '../../state/player.ts';
import type { Track } from '../../types/media.ts';
import { Note } from '../icons/media.tsx';
import { Equaliser, Row } from './Row.tsx';
import styles from './Sheet.module.css';

export interface TrackListProps {
  tracks: readonly Track[];
  header?: string;
}

const subtitleOf = (t: Track): string => [t.artist, t.album].filter(Boolean).join(' · ');

export const TrackList: Component<TrackListProps> = (props) => (
  <>
    <Show when={props.header}>{(header) => <div class={styles.section}>{header()}</div>}</Show>

    <For each={props.tracks}>
      {(item, index) => {
        const isPlaying = (): boolean => currentTrack()?.id === item.id;
        return (
          <Row
            title={item.title}
            subtitle={subtitleOf(item)}
            glyph={<Note />}
            artworkUrl={item.source === 'youtube' ? item.artworkUrl : null}
            track={item}
            playing={isPlaying()}
            tail={isPlaying() ? <Equaliser /> : item.duration ? fmtTime(item.duration) : ''}
            onSelect={() => playFromList(item, props.tracks, index())}
          />
        );
      }}
    </For>
  </>
);
